module.exports = SPAUI_COLUMNS;